Object.defineProperty(exports,"__esModule",{value:true});exports.default=







clearFromIds;function clearFromIds(topic){
return topic.split('/').reduce(function(cleanedTopic,component){
var componentNameWithoutID=component.split(':')[0];
return cleanedTopic+'/'+componentNameWithoutID;
},'');
}